<template>
  <div class="row mx-auto text-center">
    <h1 class="text-plum mb-lgp">
      {{ title }}
    </h1>
    <div class="content d-flex flex-column gap-lgp justify-content-center mx-auto">
      <slot name="aboveBox"/>
      <div
        v-if="$slots.boxContent"
        class="w-100 py-lgp px-xl bg-white border-orchid">
        <slot name="boxContent"/>
      </div>
      <slot name="belowBox"/>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: 'Membership Overview'
  }
})
</script>
<style scoped>
.content {
    max-width: 530px;
}
</style>